import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const language = localStorage.getItem('preferredLanguage') || 'nl-be';

        request = request.clone({
            setHeaders: {
                'accept-Language': language
            }
        });

        if (!request.url.includes('assets')
            && !request.url.includes('/Token')
            && !request.url.includes('/Password/Forgot')) {
            const token = localStorage.getItem('token');
            request = request.clone({
                setHeaders: {
                    authorization: `Bearer ${token}`
                }
            });
        }

        return next.handle(request);
    }
}